import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../helpers';
import { utilHelper } from '../../helpers';

import Confirm from '../Dialog/Confirm';
import { commonService, siteService, firmwareMngService } from '../../services';
import { alertActions } from '../../modules/alert';
import { DamdangOfficeSelect, DamdangOrgSelect, SiteNameInput, SiteNumInputSiteFinder } from '../Common/InputBox';


class FirmwareAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pubType: "now",
            title: "",
            version: "",
            allPubType: "",
            damdangOrg: "",
            damdangOffice: "",
            siteID: "",
            siteName: "",
            siteNum: "",
            opbID: "",
            uploadFiles: "",

            siteOpbList: [],
            orgCodes: [],
            officeCodes: [],

            valueChange: false,
            siteFinder: false,
            extCheck: false,
            submitted: false,

            open: false,
            open2: false,
            message: "",
        }

        this.setCommonCodes();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.damdangOrg !== this.state.damdangOrg) {
            this.setOfficeCodes();
        }
    }

    setCommonCodes = async () => {
        commonService.findOrgCodes()
            .then(response => {
                this.setState({ orgCodes: response.data })
            })
            .catch(this.handleErrors);
    };

    setOfficeCodes = async () => {
        this.setState({
            damdangOffice: (this.state.siteFinder ? this.state.damdangOffice : ''),
            officeCodes: []
        });
        if (this.state.damdangOrg && this.state.damdangOrg !== "") {
            commonService.findOfficeCodes(this.state.damdangOrg)
                .then(response => {
                    const officeCodes = response.data.filter(office => office.code !== "");
                    this.setState({ officeCodes: officeCodes });
                })
                .catch(this.handleErrors);
        }
    };

    // 현장선택 후 호기호출
    handleSiteInfo = (siteInfo) => {
        this.setState({
            damdangOrg: siteInfo.damdangOrg,
            damdangOffice: siteInfo.damdangOffice,
            siteID: siteInfo.siteID,
            siteName: siteInfo.siteName,
            siteNum: siteInfo.siteNum,
            opbID: "",
            siteFinder: true
        });

        let formData = new FormData();
        formData.append('siteID', siteInfo.siteID);
        formData.append('findFlag', 'F');
        siteService.getSiteInfo(formData)
            .then(response => {
                this.setState({
                    siteOpbList: response.data.siteOpbList
                })
            })
            .catch(this.handleErrors)
    };

    handleValueChange = (e) => {
        const { name, value } = e.target;
        if (name === "title" && value.length > 100) {
            // title 100자 체크
            this.props.errorAlerts("경고 100자 초과");
        }
        else if (name === "version" && value.length > 20) {
            // version 20자 체크
            this.props.errorAlerts("경고 20자 초과");
        }
        else if (name === "version" && !(utilHelper.isNumber(value) || value === "")) {
            // version 숫자 체크
            this.props.errorAlerts("숫자만 입력하세요.");
        }
        else if (name === "damdangOrg" || name === "damdangOffice") {
            // org, office 변경시 siteID, siteName, opbID 초기화
            this.setState({
                valueChange: true,
                damdangOrg: name === "damdangOrg" ? value : this.state.damdangOrg,
                damdangOffice: name === "damdangOffice" ? value : "",
                siteID: "",
                siteName: "",
                siteNum: "",
                opbID: "",
                siteFinder: false
            });
        }
        else if (name === "siteName" || name === "siteNum") {
            this.setState({
                valueChange: true,
                siteOpbList: [],
                siteID: "",
                opbID: "",
                siteName: "",
                siteNum: "",
                [name]: value,
            });
        }
        else if (name === "opbID") {
            this.setState({
                valueChange: true,
                opbID: (value === "") ? "" : parseInt(value),
            });
        }
        else {
            this.setState({
                valueChange: true,
                [name]: value
            });
        }
    };

    handleFileChange = (e) => {
        this.setState({
            valueChange: true,
            extCheck: false,
            [e.target.name]: e.target.files[0] ? e.target.files[0] : this.state.uploadFiles,
        }, () => { this.handleExtCheck(); });
    };

    // 첨부파일의 확장자 체크
    handleExtCheck = () => {
        let extCheck = false;
        let uploadFilesExt = (this.state.uploadFiles.name.substr(-4).toUpperCase() || "");
        if (uploadFilesExt === ".ZIP") {
            this.setState({
                extCheck: true
            });
            extCheck = true;
        }

        return extCheck;
    };

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    };

    handleAddButton = (e) => {
        e.preventDefault();

        this.setState({
            submitted: true
        });

        if (this.validation()) {
            let allPubType = "";
            let message = "";

            if (this.state.siteID !== "") {
                allPubType = "siteID";
                message = this.state.siteName + "에 속한 모든 Display에";
            }
            if (this.state.opbID !== "" && this.state.opbID !== -1) {
                allPubType = "opbID";
                message = (this.state.siteOpbList && this.state.siteOpbList.length > 0) ? this.state.siteOpbList.filter(siteOpb => siteOpb.opbID === this.state.opbID)[0].opbName + "에" : "";
            }

            if (allPubType) {
                this.setState({
                    allPubType: allPubType,
                    message: `${message}\n${this.state.pubType === "derv" ? "예약" : "즉시"} 배포합니다.`,
                    open2: true
                });
            }
        }
    };

    validation = () => {
        if (!this.state.title) {
            this.props.errorAlerts("제목은 필수 입력 값입니다.");
            return false;
        } else if (!this.state.damdangOrg || (this.state.damdangOrg && !this.state.damdangOffice)) {
            this.props.errorAlerts("소속은 필수 입력 값입니다.");
            return false;
        } else if (!this.state.siteID) {
            this.props.errorAlerts("현장찾기를 통해 현장을 선택하세요.");
            return false;
        } else if (!this.state.opbID) {
            this.props.errorAlerts("Display번호는 필수 입력 값입니다.");
            return false;
        } else if (!this.state.version) {
            this.props.errorAlerts("버전은 필수 입력 값입니다.");
            return false;
        } else if (!this.state.uploadFiles) {
            this.props.errorAlerts("첨부파일은 필수 입력 값입니다.");
            return false;
        } else if (!this.state.extCheck) {
            this.props.errorAlerts("확장자를 확인하세요.");
            return false;
        } else
            return true;
    };

    addFirmware = () => {
        let formData = new FormData();

        formData.append('title', this.state.title);
        formData.append('version', this.state.version);
        formData.append('allPubType', this.state.allPubType);
        formData.append('damdangOrg', this.state.damdangOrg);
        formData.append('damdangOffice', this.state.damdangOffice);
        if (this.state.siteID !== "" && this.state.siteID !== -1) formData.append('siteID', this.state.siteID);
        if (this.state.opbID !== "" && this.state.opbID !== -1) formData.append('opbID', this.state.opbID);
        formData.append('pubType', "now");
        formData.append('target', "firmware");
        formData.append('uploadFiles', this.state.uploadFiles);
        formData.append('dervStartTime', "00:00");
        formData.append('dervEndTime', "23:59");

        firmwareMngService.addFirmware(formData)
            .then(response => {
                if (response.status === 200) {
                    history.goBack();
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };


    handleClose = () => {
        if (this.state.valueChange) {
            this.setState({
                open: true
            });
        }
        else {
            this.handleGoBack();
        }
    };

    handleGoBack = () => {
        history.goBack();
    };

    handleConfirmClose = () => {
        this.setState({
            open: false,
            open2: false
        })
    };


    render() {
        const { title, version, damdangOrg, damdangOffice, siteID, siteName, siteNum, opbID, uploadFiles, extCheck, submitted, siteOpbList, orgCodes, officeCodes } = this.state;
        return (
            <>
                <h2 className="s-page-tit">즉시 패치 등록</h2>
                <div className="search-result-wrapper firmware-add s-normal-box">
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>소속</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">&nbsp;</div>
                        </div>
                        <div className="col col-lg-10 col-9">
                            <div className="row inner-row">
                                <div className="col">
                                    <DamdangOrgSelect orgCodes={orgCodes} damdangOrg={damdangOrg} handleValueChange={this.handleValueChange} />
                                </div>
                                <div className="col">
                                    <DamdangOfficeSelect officeCodes={officeCodes} damdangOrg={damdangOrg} damdangOffice={damdangOffice} handleValueChange={this.handleValueChange} />
                                </div>
                            </div>
                            {submitted && (!damdangOrg || (damdangOrg && !damdangOffice)) &&
                                <div className="text-color-red">* 소속을 입력하세요.</div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>PrjNo</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">&nbsp;</div>
                        </div>
                        <div className="col col-lg-10 col-9">
                            <SiteNumInputSiteFinder opbSearch={this.state} siteNum={siteNum} handleValueChange={this.handleValueChange} handleSiteInfo={this.handleSiteInfo} />
                            {submitted && !siteID &&
                                <div className="text-color-red">* PrjNo를 다시 검색하세요.</div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>현장명</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">&nbsp;</div>
                        </div>
                        <div className="col col-lg-10 col-9">
                            <SiteNameInput siteName={siteName} handleValueChange={this.handleValueChange} />
                            {submitted && !siteID &&
                                <div className="text-color-red">* 현장명을 다시 검색하세요.</div>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>Display번호</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">&nbsp;</div>
                        </div>
                        <div className="col col-lg-10 col-9 text-align-left">
                            <select className={`input-box w100per padding-l10 ${(siteID === "") && "disabled-select"}`} name="opbID" value={opbID} onChange={this.handleValueChange} disabled={siteID === ""}>
                                <option value="" >Display 선택</option>
                                <option value="-1">전체</option>
                                {siteOpbList && siteOpbList.length > 0 &&
                                    siteOpbList.map((siteOpb, i) => {
                                        return <option key={i} value={siteOpb.opbID}>{siteOpb.opbName} ({siteOpb.imei ? siteOpb.imei : "IMEI 없음"})</option>;
                                    })
                                }
                            </select>
                            {submitted && !opbID &&
                                <div className="text-color-red">* Display을 입력하세요.</div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>제목</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">({title.length}/100)</div>
                        </div>
                        <div className="col col-lg-10 col-9 text-align-left">
                            <input className="input-box w100per padding-l10" type="text" name="title" value={title} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                            {submitted && !title &&
                                <div className="text-color-red">* 제목을 입력하세요.</div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>버전</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">({version.length}/20)</div>
                        </div>
                        <div className="col col-lg-10 col-9 text-align-left">
                            <input className={`input-box w100per padding-l10`} type="text" name="version" value={version} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                            {submitted && !version &&
                                <div className="text-color-red">* 버전을 입력하세요.</div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-lg-2 col-3 firmware-add-title">
                            <div>첨부파일</div>
                            <div className="text-color-red">*</div>
                            <div className="firmware-add-title-length">&nbsp;</div>
                        </div>
                        <div className="col col-lg-10 col-9 text-align-left">
                            <label className="w100per">
                                <input className="contents-input-file" type="file" name="uploadFiles" onChange={this.handleFileChange} />
                                <div className="contents-input-file-name" style={{ cursor: "pointer" }}>{(uploadFiles && uploadFiles.name) || "ZIP 파일을 업로드해주세요."}</div>
                                <div className="contents-input-file-button" style={{ cursor: "pointer" }}>첨부하기</div>
                            </label>
                            {submitted && !uploadFiles &&
                                <div className="text-color-red">* 첨부파일을 업로드하세요.</div>
                            }
                            {submitted && uploadFiles && !extCheck &&
                                <div className="text-color-red">* 확장자를 확인하세요.</div>
                            }
                        </div>
                    </div>
                </div>
                <div className="search-button-wrapper text-align-right">
                    <button className={`button w100-button margin-r10`} onClick={this.handleAddButton} ref={button => this.buttonAdd = button} >등록</button>
                    <button className="button w100-button white-button" onClick={this.handleClose}>닫기</button>
                </div>
                {this.state.open === true &&
                    <Confirm message={"취소하시겠습니까?\n입력된 정보는 삭제됩니다."} kind={"fail"} handleFormSubmit={this.handleGoBack} handleClose={this.handleConfirmClose} />
                }
                {this.state.open2 === true &&
                    <Confirm message={this.state.message} kind={"save"} handleFormSubmit={this.addFirmware} handleClose={this.handleConfirmClose} />
                }
            </>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(FirmwareAdd);